export default "__VITE_ASSET__9decfed9__"